import React from 'react';
import CityPage from '../CityPage/CityPage';
import image from './Kingston.jpeg';

const KingstonPage = () => (
  <CityPage
    city="Kingston"
    region="Ontario"
    country="Canada"
    countryCode="CA"
    routePath="/kingston"
    currentPage="KingstonPage"
    image={image}
    imageAlt="Boat rentals in Kingston, Ontario on Lake Ontario"
    intro="Kingston sits where Lake Ontario meets the St. Lawrence River and the Cataraqui — a launch point for the Thousand Islands and one of the most iconic boating destinations in Canada. WetRentals connects you directly with local hosts offering Sea-Doos, pontoons, fishing boats, sailboats and more."
    sections={[
      {
        heading: 'Where to boat in Kingston',
        body:
          "From downtown harbour and Confederation Basin, head into the Thousand Islands, explore Wolfe Island and Howe Island, or run up the Rideau Canal system toward Westport. Lake Ontario opens to the south for bigger water days.",
      },
      {
        heading: 'What you can rent in Kingston',
        body:
          'Sea-Doo and Jet Ski rentals for the harbour and Thousand Islands, pontoon boats for family cruises, fishing boats for bass, pike and salmon on Lake Ontario, plus kayaks, canoes and paddleboards for the Rideau and inland lakes.',
      },
      {
        heading: 'Why book with WetRentals in Kingston',
        body:
          "WetRentals is Canada's largest peer-to-peer boat rental platform. Every booking includes safety equipment, instant confirmation, host messaging and a flexible cancellation policy — perfect for Kingston's summer-busy weekends.",
      },
    ]}
    searchUrl="/s?address=Kingston%2C%20Ontario%2C%20Canada&bounds=45.06411582%2C-75.74332275%2C43.61581436%2C-77.20339308&mapSearch=true"
    searchLabel="Browse all boat rentals in Kingston"
    showMembershipBanner
  />
);

export default KingstonPage;
